export default __webpack_public_path__ + "calender-icon-gray.svg";